export interface IPage {
    page: number;
    pageSize: number;
}

export const initialPageModel: IPage =
    {
        page: 1,
        pageSize: 10
    };


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/state-helpers/page.ts